import { z } from 'zod';
import { platformApprovedActionProviderDescriptorV2Schema, platformApprovedActionProviderRequestV2Schema, platformApprovedActionProviderResultV2Schema, platformApprovedActionProviderSlot, platformReceiptBoundActionProviderHostCapability, } from '@crest/platform-contracts/hosts';
export const workforceAssistantActivityActionProviderId = 'workforce.assistant-activity-actions';
export const workforceAssistantActivityActionProviderCapability = 'workforce.assistant-activity-actions.v1';
export const workforceAssistantActivityActionSlot = platformApprovedActionProviderSlot;
export const workforceActivityCreateActionId = 'workforce.activity-create.v1';
export const workforceActivityUpdateActionId = 'workforce.activity-update.v1';
export const workforceArchiveAssistantCreatedActivityActionId = 'workforce.archive-assistant-created-activity.v1';
export const workforceSupersedeAssistantActivityRevisionActionId = 'workforce.supersede-assistant-activity-revision.v1';
export const workforceAssistantActivityCategorySchema = z.enum([
    'late-arrival',
    'left-early',
    'no-call-no-show',
    'positive-recognition',
    'safety-observation',
    'customer-feedback',
]);
const uuid = z.string().uuid();
const representableText = /^(?:[^\u0000\uD800-\uDFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF])*$/;
const reason = z.string().trim().min(10).max(500).regex(representableText);
const revision = z.number().int().positive().max(2_147_483_646);
const summary = z.string().trim().min(1).max(500).regex(representableText);
const occurrence = z.string().datetime({ offset: true });
const note = z.string().trim().min(1).max(2_000).regex(representableText);
export const workforceActivityCreateInputSchema = z.strictObject({
    targetMembershipId: uuid,
    category: workforceAssistantActivityCategorySchema,
    occurredAt: occurrence,
    note,
    reason,
});
export const workforceActivityCreateInputSchemaHash = 'ffea02d68c4bc66fff3b76acaa84cb212555c57ad962bfb1b29abe655e2f6981';
export const workforceActivityUpdateInputSchema = z.strictObject({
    targetActivityId: uuid,
    expectedRevision: z.number().int().positive().max(2_147_483_645),
    category: workforceAssistantActivityCategorySchema,
    occurredAt: occurrence,
    note,
    reason,
});
export const workforceActivityUpdateInputSchemaHash = '367b2e0a2f13f997c8b5f4d9b0a03f1396820b8f06b58883a6cfbe3aedbd1ac5';
export const workforceArchiveAssistantCreatedActivityInputSchema = z.strictObject({
    targetActivityId: uuid,
    originalExecutionId: uuid,
    expectedRevision: revision,
    reason,
    compensationSummary: summary,
});
export const workforceArchiveAssistantCreatedActivityInputSchemaHash = '0b2098af36b234e2a1c7551e843b5e0e89dc802e11f00e6732c49d15e3af038f';
export const workforceSupersedeAssistantActivityRevisionInputSchema = z.strictObject({
    targetActivityId: uuid,
    originalExecutionId: uuid,
    expectedRevision: revision,
    reason,
    restorationSummary: summary,
});
export const workforceSupersedeAssistantActivityRevisionInputSchemaHash = '3f77197b0e4bd0be7f292acd24108817b473c27eac8f9a010a141d9e2a22407a';
const assistantPolicy = (effectClass, reversalKind, registeredReversalActionId, inputSchemaHash) => ({
    policyContractVersion: 'platform.assistant-action-policy.v1',
    confirmation: 'explicit',
    effectClass,
    externalEffectClass: 'none',
    reversal: { kind: reversalKind, registeredReversalActionId },
    ownerReadbackRequired: true,
    inputSchemaHash,
});
export const workforceAssistantActivityActionProviderDescriptor = platformApprovedActionProviderDescriptorV2Schema.parse({
    kind: 'descriptor',
    contractVersion: platformReceiptBoundActionProviderHostCapability,
    providerId: workforceAssistantActivityActionProviderId,
    providerCapability: workforceAssistantActivityActionProviderCapability,
    displayName: 'Workforce approved activity actions',
    actions: [{
            actionId: workforceActivityCreateActionId,
            displayName: 'Record Workforce activity',
            targetResourceType: 'platform.tenant-membership',
            inputSchemaHash: workforceActivityCreateInputSchemaHash,
            requiredPermission: 'workforce.activity.manage',
            assistantPolicy: assistantPolicy('compensating-write', 'compensating-action', workforceArchiveAssistantCreatedActivityActionId, workforceActivityCreateInputSchemaHash),
        }, {
            actionId: workforceActivityUpdateActionId,
            displayName: 'Correct Workforce activity',
            targetResourceType: 'workforce.activity-record',
            inputSchemaHash: workforceActivityUpdateInputSchemaHash,
            requiredPermission: 'workforce.activity.manage',
            assistantPolicy: assistantPolicy('superseding-write', 'superseding-write', workforceSupersedeAssistantActivityRevisionActionId, workforceActivityUpdateInputSchemaHash),
        }, {
            actionId: workforceArchiveAssistantCreatedActivityActionId,
            displayName: 'Archive Assistant-created Workforce activity',
            targetResourceType: 'workforce.activity-record',
            inputSchemaHash: workforceArchiveAssistantCreatedActivityInputSchemaHash,
            requiredPermission: 'workforce.activity.manage',
            assistantPolicy: assistantPolicy('compensating-write', 'compensating-action', null, workforceArchiveAssistantCreatedActivityInputSchemaHash),
        }, {
            actionId: workforceSupersedeAssistantActivityRevisionActionId,
            displayName: 'Supersede Assistant Workforce activity revision',
            targetResourceType: 'workforce.activity-record',
            inputSchemaHash: workforceSupersedeAssistantActivityRevisionInputSchemaHash,
            requiredPermission: 'workforce.activity.manage',
            assistantPolicy: assistantPolicy('superseding-write', 'superseding-write', null, workforceSupersedeAssistantActivityRevisionInputSchemaHash),
        }],
});
export const workforceAssistantActivityActionProviderRequestSchema = platformApprovedActionProviderRequestV2Schema;
export const workforceAssistantActivityActionProviderResultSchema = platformApprovedActionProviderResultV2Schema;
//# sourceMappingURL=workforce-assistant-activity-actions.contract.js.map